<template>
  <div class="main system_main">
    <div class="tree_nav">
      <li v-for="(item, index) in monitor" :key="index" @click="imonitor(item)" :class="item.indexData ==tabIndex ? 'active' : ''">
        <el-input @change="changeInput" class="menuInput" v-model="item.name" />
        <el-button class="menuButton" type="text" @click.stop="clickHidden(item)">{{ item.hidden===1?'显示':'隐藏' }}</el-button>
      </li>
    </div>
    <div class="main_content">
      <div class="ss_title">{{sstitle}}</div>
      <div v-if="tabIndex==1">
        首页无需设置
      </div>
      <recommend v-if="tabIndex==2"></recommend>
      <Power v-if="tabIndex==3"></Power>
      <safety v-if="tabIndex==4"></safety>
      <Device v-if="tabIndex==5"></Device>
      <produce v-if="tabIndex==6"></produce>
      <Sale v-if="tabIndex==7"></Sale>
      <transportation v-if="tabIndex==8" />
    </div>
  </div>
</template>
<script>
import api from '@/apis/SystemSetting'

import recommend from './recommend/index.vue'
import Power from './power/power'
import Device from './device/index'
import safety from './safety/index'
import produce from './produce/index'
import Sale from './sale/index'
import transportation from './transportation/index'
export default {
  components: {
    recommend,
    Power,
    Device,
    safety,
    produce,
    Sale,
    transportation,
  },
  data() {
    return {
      monitor: [
        { indexData: 1, name: '首页', hidden: 1 }, ///hidden 1显示 2 隐藏
        { indexData: 2, name: '企业简介', hidden: 1 }, ///hidden 1显示 2 隐藏
        { indexData: 3, name: '能源管理', hidden: 1 },
        { indexData: 4, name: '安全管理', hidden: 1 },
        { indexData: 5, name: '设备管理', hidden: 1 },
        { indexData: 6, name: '生产系统', hidden: 1 },
        { indexData: 7, name: '销售系统', hidden: 1 },
        { indexData: 8, name: '物流系统', hidden: 1 },
      ],
      sstitle:'',
      tabIndex: 1,
    };
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      api
        .list()
        .then((res) => {
          if (res.code === 10000) {
            console.log(res);
            if (res.data.length) {
              this.monitor = res.data
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    //左侧tab切换
    imonitor(row) {
      row
      this.tabIndex = row.indexData
      // for (var i = 0; i <= this.monitor.length - 1; i++) {
      //   this.monitor[i].active = false
      // }
      // this.monitor[row - 1].active = true;
      // this.sstitle=this.monitor[row-1].text;
    },

    clickHidden(item){
      // if (item.indexData == 8) {
      //   return this.$message.warning('请不要手贱！')
      // }
      item.hidden= item.hidden===1?2:1;
      console.log(item);
      
      this.saveMenu()

    },
    changeInput(){
      this.saveMenu()
    },

    saveMenu(){
      api
        .save(this.monitor)
        .then((res) => {
          if (res.code === 10000) {
            this.$message.success(res.message)
          } else {
            this.$message.error(res.message)
          }
        }).finally(()=>{
          this.getList()
        })
    },







  },
}
</script>

<style lang="less" scoped>
.main {
  flex: 1;
  display: flex;
  flex-direction: row;
  padding: 2rem;
  width: 100%;
  height: 100%;
  overflow: hidden;

  ::v-deep .menuInput{
    .el-input__inner{
      text-align: center;
      border:none;
      cursor: pointer;
    }
  }
  .menuButton{
    position: absolute;

    padding: 0.25rem 0.5rem;
  }

  .main_content {
    flex: 1; width: 100%; 
    padding:1.5rem; position: relative; overflow: hidden;
    // .ss_title{ position: absolute; top: -46px; left: -2px; background: url(../../assets/images/ss_title.png) no-repeat;
    //   background-size: 100% 100%; width: 242px; line-height: 50px; height: 64px; color: #00ccff; font-size: .8rem; font-weight: bold;
    //   padding-left: 42px;letter-spacing:8px;
    // }

  }

  .tree_nav {
    width: 10rem; flex-shrink: 0;
    margin: 2rem;
    li {
      position: relative;
      background: url(../../assets/images/tree_navbg.png) no-repeat;
      background-size: 100% 100%;
      height: 1.6rem; cursor: pointer; font-size: .9rem;
      margin-bottom: 1rem;
      line-height: 1.6rem;
      text-align: center; transition: all .2s ease 0s;
    }
    li.active {
      background: url(../../assets/images/tree_navbg_active.png) no-repeat;
      background-size: 100% 100%;
      color: #fff;
    }
    li:hover{
      transform: translate(10px,0);
    }
  }


}


</style>
<style lang="less">
.main{
  .main_content{
    .el-form-item__label{ background: #3570ff;}
  }
}

</style>
